import { styled } from 'parkdepot-shared/theme'

export const Title = styled('h6', ({ $theme }) => ({
    margin: 0,
    ...$theme.typography.LabelMedium,
    fontWeight: 700
}))

export const CirclesContainer = styled('div', () => ({
    marginTop: '2.4rem',
    display: 'flex',
    gap: '2rem',
    justifyContent: 'center',
    alignItems: 'center'
}))

export const Circle = styled('div', ({ $theme }) => ({
    backgroundColor: '#F6F6F6',
    borderRadius: '50%',
    width: '50px',
    height: '50px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    cursor: 'pointer'
}))

export const DurationWarningTitle = styled('h6', ({ $theme }) => ({
    margin: 0,
    ...$theme.typography.ParagraphSmall,
    fontWeight: 600,
    color: '#000',
    marginTop: '1.6rem'
}))

export const DurationWarningText = styled('p', ({ $theme }) => ({
    margin: '0.4rem 0 0 0',
    ...$theme.typography.ParagraphSmall,
    color: '#000',
    fontWeight: 400
}))

export const Icon = styled<'i', { disabled: boolean }>('i', ({ $theme, disabled = false }) => ({
    color: disabled ? $theme.colors.primary : '#AFAFAF',
    fontSize: '3rem'
}))

export const NumberInput = styled('input', () => ({
    border: '2px solid #E5E5E5',
    borderRadius: '24px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '6.4rem',
    height: '6.4rem',
    textAlign: 'center',
    fontSize: '2.4rem',
    fontWeight: '600',
    lineHeight: '3.2rem'
}))

export const TimeSelectionSection = styled('div', ({ $theme }) => ({
    [$theme.mediaQuery.small]: {
        flexShrink: 0
    },
    [$theme.mediaQuery.medium]: {
        textAlign: 'center'
    },
    [$theme.mediaQuery.large]: {
        textAlign: 'center'
    }
}))
